import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { SchoolSetupState } from 'Src/models/school';

export function getSchoolSetup(user: AppUser): Promise<SchoolSetupState> {
  return axios
    .get(`${window.apiBase}/i/schools/${user.activeSchoolId}/setup`, { headers: { usid: user.roleSessionKey } })
    .then(response => response.data);
}

export function updateSchoolSetupSection(
  user: AppUser,
  sectionKey: string,
  status: 'IN_PROGRESS' | 'COMPLETED' | 'SKIPPED' | 'NEEDS_REVIEW'
): Promise<SchoolSetupState> {
  return axios
    .patch(
      `${window.apiBase}/i/schools/${user.activeSchoolId}/setup/sections/${sectionKey}`,
      { status, version: 1 },
      { headers: { usid: user.roleSessionKey } }
    )
    .then(response => response.data);
}

export function updateSchoolSetupStatus(user: AppUser, status: 'IN_PROGRESS' | 'COMPLETED'): Promise<SchoolSetupState> {
  return axios
    .patch(
      `${window.apiBase}/i/schools/${user.activeSchoolId}/setup`,
      { status },
      { headers: { usid: user.roleSessionKey } }
    )
    .then(response => response.data);
}
